import ReactiveWidget from "lib/reactiveWidget";

import $              from "jquery"
import select2        from "select2"
import "select2/dist/css/select2.min.css"
import "select2-bootstrap-theme/dist/select2-bootstrap.min.css"
import fetchGroups from "servos/fetchGroupData";
import fetchVehicles from "servos/fetchVehicleData";
import applyLocalTimeZone from "servos/applyLocalTimeZone";

class EditTenderWidget extends ReactiveWidget  {
  bind() {
    this.form = this.root.find('form')
    this.form.find('.loading-spinner').hide()
    stopSpinner.call(this)
    bindFormActions.call(this)

    // Fetch the data
    resetPage.call(this)
    fetchVehicles.call(this, '#edit', this.form.serializeArray())
  }

  render() {
  }
}

var bindFormActions = function() {
  this.root.on('keyup', '.search-query', (e) => {
    delay(() => {
      resetPage.call(this)
      fetchVehicles.call(this, '#edit', this.form.serializeArray())
    }, 300 );
  })

  // Select 2
  let select2_elem = this.form.find(".filter-select2")
  $(select2_elem).select2({
    placeholder: 'Select',
    allowClear: true,
    tags: true,
    theme: "bootstrap",
    templateSelection : function (tag, container){
      // here we are finding option element of tag and
      // if it has property 'locked' we will add class 'locked-tag'
      // to be able to style element in select

      var $option = $(select2_elem).find(' option[value="'+tag.id+'"]');
      if ($option.attr('locked')){
        $(container).addClass('locked-tag');
        tag.locked = true;
      }
      return tag.text;
    },
  }).on('select2:unselecting', function(e){
      // before removing tag we check option element of tag and
      // if it has property 'locked' we will create error to prevent all select2 functionality
      if ($(e.params.args.data.element).attr('locked')) {
        e.preventDefault()
      }
  }).on('change', (e) => {
    resetPage.call(this)
  })

  // Select 3
  let select3_elem = this.form.find(".filter-select3")
  $(select3_elem).select2({
    placeholder: 'Select',
    allowClear: true,
    theme: "bootstrap"
  })

  // Pagination
  // let pagination_links = this.root.find('.pagination a')/
  this.root.on('click', '.pagination a', (e) => {
    e.preventDefault()
    e.stopPropagation()

    let url   = $(e.target).attr('href')
    this.form.find("input[name='page']").val(window.getSearchParams(url, 'page') || "0")
    fetchVehicles.call(this, '#edit', this.form.serializeArray())
  })

  // Capture Country Select
  let country_select = this.form.find(".sort-by-country")
  $(country_select).select2({
    placeholder: 'Select',
    allowClear: true,
    theme: "bootstrap"
  }).on('change', (e) => {
    applyLocalTimeZone.call(this)
    fetchGroups.call(this, this.form.serializeArray())
    fetchVehicles.call(this, '#edit', this.form.serializeArray())
    resetPage.call(this)
  })

  // Capture Form Submit
  this.form.on('submit', (e) => {
    e.preventDefault();
    fetchVehicles.call(this, '#edit', this.form.serializeArray())
    return false
  })
}

var resetPage = function() {
  this.form.find("input[name='page']").val('0')
}

var startSpinner = function() {
  this.form.find('.loading-spinner').fadeIn(400)
}

var stopSpinner = function() {
  this.form.find('.loading-spinner').fadeOut(400)
}

export default EditTenderWidget
